import { CONTACT, PublicPage, Section, UPDATED } from "../../components/PublicLayout";

export default function Privacy() {
  return (
    <PublicPage testId="public-privacy-page" eyebrow="Privacy Policy" title="Privacy Policy" updated={UPDATED}>
      <Section title="Who we are">
        <p data-testid="privacy-operator-intro">This Privacy Policy is provided by CampbellsLife LLC, doing business as GamedayTime (&ldquo;GamedayTime&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;). GamedayTime is a timekeeping app for our employees and crew. GamedayTime is a DBA of CampbellsLife LLC. Contact: <a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a>.</p>
      </Section>
      <Section title="Information we collect">
        <ul className="list-disc space-y-1 pl-5">
          <li>Name, email address and mobile number</li><li>Account status, shift assignments and timekeeping records</li>
          <li>A one-time location (coordinates and accuracy) at each clock punch</li><li>Device/browser information and IP address at punch time</li>
          <li>Correction requests</li><li>Pay-period hours and wage records</li><li>Your payment method election and records of payments made to you</li>
        </ul>
      </Section>
      <Section title="How we use it">
        <p>Timekeeping, payroll records, identity and phone verification, support, security and legal compliance.</p>
        <p><strong>We do not sell personal information.</strong></p>
      </Section>
      <Section title="Text messages (SMS)" id="sms">
        <p data-testid="privacy-sms-statement">Mobile information will not be shared with third parties or affiliates for marketing or promotional purposes. Text messaging originator opt-in data and consent will not be shared with any third parties. Information may be shared with service providers that help us deliver messages (e.g. our SMS provider) solely to provide the service.</p>
      </Section>
      <Section title="Service providers">
        <p>We use an SMS provider (Twilio), an email provider, a hosting provider, and a map/geocoding service (OpenStreetMap) that is used for venue addresses only, never for employee location.</p>
      </Section>
      <Section title="Location">
        <p>Location is collected only when you tap to share it for a clock punch. There is no continuous tracking. Precise coordinates are kept for up to 3 years and then deleted; the pass/fail result of each check is kept.</p>
      </Section>
      <Section title="Retention">
        <p>We keep timekeeping and payroll records for as long as needed for payroll and legal record-keeping, then delete or anonymize them.</p>
      </Section>
      <Section title="Security">
        <p>Access is limited to authorized administrators using passwords and authenticator codes. Data is encrypted in transit, and sensitive fields are encrypted at rest.</p>
      </Section>
      <Section title="Access and correction">
        <p>You can view your timesheets in the app and request corrections there. For other access or correction requests, email <a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a>.</p>
      </Section>
      <Section title="Children">
        <p>GamedayTime is not directed to children and is not intended for anyone under 18.</p>
      </Section>
      <Section title="Changes">
        <p>We may update this policy. The "Last updated" date above shows the latest version.</p>
      </Section>
      <Section title="Contact">
        <p><a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a></p>
      </Section>
    </PublicPage>
  );
}
